<template>
  <div class="bmap-page-container">

    <div class="bmap-demo" id="map_container">
      <div v-if="showErrMessage" class="errTip">地图加载失败</div>
      <Spin fix :show="dituloading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
    <Loding v-if="!dituloading" :showLoding="loading" :centerAbsolute="true"></Loding>
  </div>
</template>
 
<script>
// import { effect, util, mapvgl, mapvglThree } from 'vue-mapvgl';
import loadBMap1 from '@/libs/map'
const mapvgl = require('mapvgl')
import { cityList, cityListOne } from './json/CNCityList'
import common from '@/common/common.js';
import Loding from "../../common/Loding.vue";
import { mapState } from 'vuex'
export default {
  components: {},
  name: 'bmap-page',
  props: {
    searchObj: {
      type: Object,
      default: () => {
        return {
          status: 2,//已激活
          productTypeId: '',
          whetherOnline: ''
        }
      }
    },
    areaZoom: {
      default: () => {
        return {
          zoom: 5,
          changeZoom: false
        }
      }
    }
  },
  components: {
    Loding
  },
  data() {
    return {
      zoom: 5,//
      map: '',//
      view: '',
      iconClusterLayer: '',
      MarkerListLayer: '',
      infoWindowPOint: '',
      mapCenter: [109.50051, 36.60332],
      minZoom: 5,
      maxZoom: 25,
      dataCityList: [],// 城市列表汇总数据
      hasDataCityList:false,//是否请求过城市列表汇总数据，对于百度地图，只做国内，所以只需要初始化请求一次
      deviceList: [],
      iconIndex: 2,//设备状态
      iconColor: '#1296db',//设备状态颜色
      dituloading: true,//地图加载
      loading: false,//地图加载
      showErrMessage: false,//地图加载失败，文字展示
      chinaZone: {//中国经纬度范围，没有用到
        lngMin: 73.5,
        lngMax: 135.09,
        latMin: 3.849,
        latMax: 53.57,
      },
      areaZoomOld: 5
    };
  },
  watch: {
    areaZoom(newval) {
      if (newval) {
        this.changeMapZoom(newval)
      }

    },

  },
  async created() {
    // 对于国内地图，初始化获取全国所有城市的数据
    await this.getInitData()
  },

  mounted() {
    this.$nextTick(() => {
      this.baiduMap()
    })
  },
  destroyed() {
    this.destroyMap()
  },
  ...mapState(['selectId']),
  methods: {
    baiduMap() {
      //第一种方式引入 //此处Map('ak').then...请使用自己的ak秘钥
      loadBMap1("rQuXse6gpzSHmr1MEC4usOZtPmeULyOa").then(BMapGL => {				//调用map.js中Map()方法，引入百度地图秘钥作为参数
        this.dituloading = false
        this.showErrMessage = false
        this.initMap()
      }).catch((err) => {
        this.dituloading = false
        this.showErrMessage = true
      })

      setTimeout(() => {

        if (this.dituloading) {
          this.showErrMessage = true
          this.dituloading = false
        }
      }, 6000);


    },
    initMap() {
      this.map = ''
      this.view = ''
      this.iconClusterLayer = ''
      this.MarkerListLayer = ''


      this.map = new BMapGL.Map('map_container', { minZoom: this.minZoom, maxZoom: this.maxZoom });
      var point = new BMapGL.Point(this.mapCenter[0], this.mapCenter[1]);
      this.map.centerAndZoom(point, 5);
      this.map.enableKeyboard();
      this.map.enableScrollWheelZoom();
      this.map.enableInertialDragging();
      this.map.enableContinuousZoom();


      // 初始化执行
      this.echarsHeatmap()

      //监听地图缩放
      this.map.addEventListener("zoomend", (e) => {
        this.zoom = this.map.getZoom();
        this.$emit('getZoom', this.zoom)

        // console.log('this.zoom ', this.zoom)

        if (this.zoom < 9) {
          if (this.timerMapGetdata) {
            clearTimeout(this.timerMapGetdata)
          }
          this.timerMapGetdata = setTimeout(() => {
            this.echarsHeatmap();
          }, 800);
        }
         
        // 缩小后再次放大渲染之前的数据
        // if (this.zoom >= 10 && this.deviceList.length) {
        //    this.getIconClusterLayer()
        //   }
      });
    },
    // 根据可视区域获取设备列表------没用到可视区域

    echarsHeatmap() {
      this.removePoints()
      this.getLabelLayer()
    },
    // 自定义标签展示
    async getLabelLayer() {
     
      await this.getInitData()

      let map = this.map
      this.view = new mapvgl.View({ map })

      this.MarkerListLayer = new mapvgl.LabelLayer({
        textAlign: 'center',
        textColor: '#fc0',
        borderColor: this.iconColor,
        backgroundColor: this.iconColor,
        padding: [2, 5],
        borderRadius: 5,
        fontSize: 12,
        lineHeight: 16,
        collides: false, // 是否开启碰撞检测, 数量较多时建议打开
        enablePicked: true,
        autoSelect: true,
        onClick: async (e) => {// 点击事件
          // console.log('e', e)
          if (e.dataIndex > -1) {
            let point = new BMapGL.Point(e.dataItem.geometry.coordinates[0], e.dataItem.geometry.coordinates[1]);
            let zoom = (this.zoom + 1) > 9 ? (this.zoom + 1) : 9
            this.map.centerAndZoom(point, zoom);
            await this.getDetailData(e.dataItem.properties.cityName)
            await this.getIconClusterLayer()
          }
        },
      });

      this.view.addLayer(this.MarkerListLayer);
      this.MarkerListLayer.setData(this.dataCityList);
    },

    // 百度地图自动聚合展示详细数据
    getIconClusterLayer() {

      this.removePoints()



      let that = this
      let map = this.map
      this.view = new mapvgl.View({ map })

      console.log("this.zoomthis.zoom",this.zoom)

      this.iconClusterLayer = new mapvgl.IconClusterLayer({
        clusterRadius: 150,
        maxZoom: 25,
        minZoom: 5,
        showText: true,
        minPoints: 2,//最小聚合count值
        textOptions: {
          fontSize: 12,
          color: 'white',
          // 格式化数字显示
          format(count) {
            return count >= 10000 ? Math.round(count / 1000) + 'k'
              : count >= 1000 ? Math.round(count / 100) / 10 + 'k' : count;
          },
          stroke: {
            color: 'black'
          },
          offset: [0, 0]
        },
        iconOptions: {
          width: 40,
          height: 40,
        },
        iconExtent: {
          0: require(`@/static/images/xinxi${that.iconColor}.png`),
          1000: require(`@/static/images/xinxi${that.iconColor}.png`),
          5000: require(`@/static/images/xinxi${that.iconColor}.png`),
          10000: require(`@/static/images/xinxi${that.iconColor}.png`)
        },
        enablePicked: true,
        onClick(e) {
          if (e.dataItem) {
            if (!e.dataItem.children) {
              var opts = {
                width: 50,     // 信息窗口宽度
                height: 10,    // 信息窗口高度
                title: '设备信息：'  // 信息窗口标题
              }
              console.log('this.zoom',that.zoom)
              var point = new BMapGL.Point(e.dataItem.geometry.coordinates[0], e.dataItem.geometry.coordinates[1]);

              if (that.zoom < 15) {
                map.centerAndZoom(point, 15);
              } else {


                that.infoWindowPOint = new BMapGL.InfoWindow(`
              <div>
                <div>${that.$t("deviceManage.serialNumber")}: ${e.dataItem.properties.serialNumber}</div>
                <div>${that.$t("deviceManage.baseType")}: ${e.dataItem.properties.baseType}</div>
              </div>
            ` , opts);  // 创建信息窗口对象
                map.openInfoWindow(that.infoWindowPOint, point);        // 打开信息窗口

              }

            }

          }
        }
      })


      this.view.addLayer(this.iconClusterLayer);
      this.iconClusterLayer.setData(this.deviceList);
    },

    //清除覆盖物
    removePoints() {

      // if (this.view && this.MarkerListLayer) {
      //     this.view.removeLayer(this.MarkerListLayer);
      // }
      // if (this.view && this.iconClusterLayer) {
      //     this.view.removeLayer(this.iconClusterLayer);
      // }

      if (this.view) {
        this.view.destroy()
      }

      if (this.infoWindowPOint) {
        this.map.closeInfoWindow(this.infoWindowPOint);
      }

    },
    //传国家，给所有城市的设备汇总
    async getInitData() {
      if(this.hasDataCityList) return

      let params = {
        countryList: ['CN'],
        productTypeId: (this.searchObj.productTypeId === undefined || this.searchObj.productTypeId === '') ? null : this.searchObj.productTypeId * 1,
        whetherOnline: (this.searchObj.whetherOnline === undefined || this.searchObj.whetherOnline === '') ? null : this.searchObj.whetherOnline * 1
      }

      this.loading = true
      let result = await this.axios.post(this.config.urlArray.getCountOfEachCity, { ...params })

      if (result) {
        common.ajaxMsg(result.data, false, () => {
          let resData = result.data.data[0].citys
          let dataList = []
          let cityListAll = [...cityList, ...cityListOne]

          //   resData = [
          //       {
          //         "theCount": 1,
          //         "statisticCityName": "苏州市"
          //       },
          //       {
          //         "theCount": 3,
          //         "statisticCityName": "上海"
          //       }
              
          // ]

          resData.map(item => {
            let cityCenter = null
            for (let i = 0; i < cityListAll.length; i++) {
              if (cityListAll[i].city_name == item.statisticCityName) {
                cityCenter = [cityListAll[i].city_lng, cityListAll[i].city_lat]
                break;
              }
            }

            if (!cityCenter) {
              let cityCenterObj = mapv.utilCityCenter.getCenterByCityName(item.statisticCityName);
              if (cityCenterObj && cityCenterObj.lng) {
                cityCenter = [cityCenterObj.lng, cityCenterObj.lat]
              }
            }

            let number = item.theCount >= 10000 ? Math.round(item.theCount / 1000) + 'k'
              : item.theCount >= 1000 ? Math.round(item.theCount / 100) / 10 + 'k' : item.theCount;

            dataList.push({
              geometry: {
                type: 'Point',
                coordinates: cityCenter,
              },
              properties: {
                text: item.statisticCityName + '\n' + number+'',
                textColor: '#fff',
                borderColor: this.iconColor,
                backgroundColor: this.iconColor,
                cityName: item.statisticCityName,
                totalCount: number
              }
            })
          })
          this.dataCityList = dataList
          this.hasDataCityList = true
        });
      }
      this.loading = false





    },
     // 用于添加轻微的随机偏移量
    getRandomOffset() {
      const offset = 0.0002; // 偏移量的大小，根据需要调整
      const latOffset = (Math.random() - 0.5) * offset; // 随机纬度偏移
      const lngOffset = (Math.random() - 0.5) * offset; // 随机经度偏移
      return { latOffset, lngOffset };
    },
    // 传城市，给改城市的设备列表
    async getDetailData(cityName) {
      let params = {
        simpleCountryName: 'CN',
        statisticCityName: cityName,
        productTypeId: (this.searchObj.productTypeId === undefined || this.searchObj.productTypeId === '') ? null : this.searchObj.productTypeId * 1,
        whetherOnline: (this.searchObj.whetherOnline === undefined || this.searchObj.whetherOnline === '') ? null : this.searchObj.whetherOnline * 1
      }
      this.loading = true
      let result = await this.axios.post(this.config.urlArray.getDeviceOfOneCity, { ...params })
      if (result) {
        common.ajaxMsg(result.data, false, () => {
          let resData = result.data.data
          let dataList = []

          resData.map(item => {
            const existingMarker = dataList.find(m => m.geometry.coordinates[1] === (Number(item.lat)) && m.geometry.coordinates[0] === Number(item.lon));
            if(existingMarker){
              const { latOffset, lngOffset } = this.getRandomOffset();
              dataList.push({
                geometry: {
                  type: 'Point',
                  coordinates: [item.lon * 1+lngOffset, item.lat * 1+latOffset]
                },
                properties: {
                  icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
                  width: 20,
                  height: 30,
                  serialNumber: item.serialNumber || '',
                  baseType:item.baseType || '',
                }
              })
            }else{

              dataList.push({
                geometry: {
                  type: 'Point',
                  coordinates: [item.lon * 1, item.lat * 1]
                },
                properties: {
                  icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
                  width: 20,
                  height: 30,
                  serialNumber: item.serialNumber || '',
                  baseType:item.baseType || '',
                }
              })
            }

          })
          this.deviceList = dataList
          // this.deviceList = [
          //   {
          //     geometry: {
          //       type: 'Point',
          //       coordinates: [120.800046, 31.315556],
          //       lng: 120.800046,
          //       lat: 31.315556
          //     },
          //     properties: {
          //       icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          //       width: 20,
          //       height: 30,
          //       serialNumber: '123456789' || ''
          //     }
          //   },
          //   {
          //     geometry: {
          //       type: 'Point',
          //       coordinates: [120.800046, 31.315556],
          //       lng: 120.800046,
          //       lat: 31.315556
          //     },
          //     properties: {
          //       icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          //       width: 20,
          //       height: 30,
          //       serialNumber: '458787878' || ''
          //     }
          //   },
          //   {
          //     geometry: {
          //       type: 'Point',
          //       coordinates: [120.900046, 31.315556],
          //       lng: 120.900046,
          //       lat: 31.315556
          //     },
          //     properties: {
          //       icon: require(`@/static/images/loc_${this.iconColor}_26.png`),
          //       width: 20,
          //       height: 30,
          //       serialNumber: '5457889789789' || ''
          //     }
          //   },

          // ]
          // console.log('this.deviceList', this.deviceList)
        });
      }
      this.loading = false
    },
    // 搜索
    async searchData() {

      this.iconIndex = (this.searchObj.whetherOnline === undefined || this.searchObj.whetherOnline === '') ? 2 : this.searchObj.whetherOnline
      this.hasDataCityList  =false

      if (this.iconIndex == 2) {
        this.iconColor = '#1296db'
      } else if (this.iconIndex == 1) {
        this.iconColor = '#00a859'
      } else if (this.iconIndex == 0) {
        this.iconColor = '#d81e06'
      }

      
     
      var point = new BMapGL.Point(109.50051, 36.60332);
      this.map.centerAndZoom(point, 5);
      this.removePoints()
      await this.getLabelLayer()
    },
    //传区域等级，对地图进行缩放
    changeMapZoom(newval) {
      this.areaZoomOld = newval

      if (this.areaZoomOld == this.zoom) return
      this.map.setZoom(newval)
      if (this.infoWindowPOint) {
        this.map.closeInfoWindow(this.infoWindowPOint);
      }

      // if (newval < 9) {
      //   this.echarsHeatmap();
      // }
    },
     // 注销地图
    destroyMap() {
    
      try {
        // 注销地图（换成你初始化时定义的地图变量）
        this.map = null

        // 获取interval的最高ID然后遍历清除
        const HIGHEST_INTERVAL_ID = setInterval(';')
        for (let i = 0; i < HIGHEST_INTERVAL_ID; i++) {
          clearInterval(i)
        }

        // 获取百度地图创建的DOM并销毁
        const BAIDU_MAPS = document.querySelectorAll('#map_container')
        BAIDU_MAPS.forEach((item) => {
          document.body.removeChild(item)
        })
      } catch (e) {
        // console.log(e);
      }
    }
  }
};
</script>
 
<style lang="less" scoped>
.bmap-page-container {
  padding: 0 60px;
  position: relative;
}

.bmap-demo {
  width: 100%;
  min-width: 600px;
  height: 600px;
  margin: 20px auto;
  position: relative;

}

.errTip {
  position: absolute;
  left: 50%;
  z-index: 99;
  top: 50%;
  width: 200px;
  height: 200px;
  background-color: white;
  transform: translate(-50%, -50%);
  line-height: 200px;
  text-align: center;
  font-size: 24px;
}
</style>